import { Component, OnInit } from '@angular/core';
import { finalize } from 'rxjs';
import { ActivatedRoute, Router } from '@angular/router';
import { UserDataService } from 'src/app/core/services/user-data.service';
import { HttpClient } from '@angular/common/http';
import { IMspDashboard } from '../../models/msp-dashboard';
import { environment } from 'src/environments/environment';
import { ManagedServicesSharedDataService } from '../../services/managed-services-shared-data.service';

@Component({
  selector: 'app-dashboards',
  templateUrl: './dashboards.component.html',
  styleUrls: ['./dashboards.component.scss'],
  standalone: false,
})
export class DashboardsComponent implements OnInit {
  isLoadingDashboards: boolean = false;
  dashboards: IMspDashboard[] = [];

  constructor(
    private router: Router,
    private route: ActivatedRoute,
    private userService: UserDataService,
    private http: HttpClient,
    private mspSharedDataService: ManagedServicesSharedDataService,
  ) {}

  ngOnInit(): void {
    this.fetchDashboards();
  }

  private fetchDashboards() {
    this.isLoadingDashboards = true;

    this.http
      .get<IMspDashboard[]>(`${environment.restUrl}/v1/msp/account/${this.userService.company.id}/dashboards`)
      .pipe(finalize(() => (this.isLoadingDashboards = false)))
      .subscribe({
        next: (dashboards) => {
          this.dashboards = dashboards;
          this.mspSharedDataService.dashboards$.next(dashboards);

          const currentRoute = this.route.snapshot.firstChild?.params['dashboardType'];
          if (!currentRoute && dashboards.length > 0) {
            this.router.navigate([dashboards[0].value], { relativeTo: this.route });
          }
        },
        error: () => {
          this.isLoadingDashboards = false;
        },
      });
  }
}
